<div mat-dialog-title>
  <div
    class="modal__header"
    [class.mw-992]="isMapStep && !mappingIsEmpty">
    <div class="modal__title">
      <h1 *ngIf="!isMapStep">
        <ng-container *ngIf="isTemplate">Create {{ 'scope|l' | lang }} with a template</ng-container>
        <ng-container *ngIf="!isTemplate">Duplicate {{ 'scope' | lang }}</ng-container>
      </h1>
      <h1 *ngIf="isMapStep">
        <ng-container *ngIf="isTemplate">
          Map roles from {{ 'scope.p|l' | lang }} '{{ scopeTemplate.name }}'
        </ng-container>
        <ng-container *ngIf="!isTemplate">Duplicate {{ 'scope|l' | lang }} '{{ scopeToDuplicate.name }}'</ng-container>
      </h1>
    </div>

    <div
      *ngIf="isMapStep && !mappingIsEmpty"
      class="mt-2">
      <span>
        Please select {{ 'agency|l' | lang }} resources from '{{ ratecard!.name }} (v{{ ratecard!.version }})' rate-card
        for roles which do not exist in '{{ sourceRateCard.name }} (v{{ sourceRateCard.version }})' rate-card
      </span>
    </div>

    <button
      class="close-button"
      (click)="cancel()"
      type="button">
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content
  aria-label="Generic modal"
  class="modal-container md-dialog-container generic-modal"
  [class.mw-992]="isMapStep && !mappingIsEmpty">
  <div class="px-10 pb-2 w-full generic-modal__content">
    <div
      *ngIf="!isMapStep; else mapStep"
      class="mt-2">
      <p *ngIf="isTemplate">
        The rate card of the {{ 'scope|l' | lang }} template which you selected to use is different.
      </p>
      <p *ngIf="!isTemplate">The rate card of the {{ 'scope|l' | lang }} which you selected to use is different.</p>
      <p class="pt-1">
        This means you will need to resolve the inconsistency between '{{ sourceRateCard.name }} (v{{
          sourceRateCard.version
        }})' and '{{ myNewScope.ratecard.name }} (v{{ myNewScope.ratecard.version }})' rate cards. Would you like to
        try?
      </p>
    </div>

    <ng-template #mapStep>
      <div
        *ngIf="mappingIsEmpty"
        class="mt-2">
        <span>There are no roles to map, you may insert this scope.</span>
      </div>

      <map-roles
        *ngIf="!mappingIsEmpty"
        [sourceRateCard]="sourceRateCard"
        [ratecard]="ratecard"
        [targetRoles]="targetRoles"
        [mappingRoles]="mappingRoles">
      </map-roles>
    </ng-template>
  </div>

  <div class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
    <div class="generic-modal__buttons">
      <button
        *ngIf="!isMapStep"
        [disabled]="!deliverables || !ratecard"
        mat-flat-button
        class="ml-8"
        (click)="mapRoles()">
        {{ !deliverables || !ratecard ? '...Loading' : 'Continue' }}
      </button>
      <button
        *ngIf="isMapStep"
        mat-flat-button
        class="ml-8 mt-8"
        (click)="confirmConvertAndInsert()">
        Create
      </button>
    </div>
  </div>
</mat-dialog-content>
